exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "textarea[data-v-350dca6d] {\n  min-height: 80px;\n}\n", ""]);

// exports
